<template>
  <div class="content">
    <div class="container-fluid">
      <b-row>
        <b-col>
          <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-12">
          <b-card>
            <b-form @submit="onSubmit" @reset="onReset">

      <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.name"
          placeholder="Enter name"
          :state="nameState"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Email address:"
        label-for="input-2"
      >
        <b-form-input
          id="input-2"
          v-model="form.email"
          type="email"
          placeholder="Enter email"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-3"
        label="Phone Number"
        label-for="input-3"
      >
        <b-form-input
          id="input-3"
          v-model="form.phone"
          type="tel"
          placeholder="Enter Phone"
          maxlength="10"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-4" label="Role:" label-for="input-4">
        <b-form-select
          id="input-4"
          v-model="form.role"
          :options="roles"
          required
        ></b-form-select>
      </b-form-group>
      <b-form-group id="input-group-5" label="Outlet:" label-for="input-5">
        <multiselect id="input-5" v-model="form.outlet" :options="outlets" placeholder="Select Outlet" :custom-label="nameWithCode" label="name" track-by="name"></multiselect>
      </b-form-group>
      <b-form-group
        id="input-group-6"
        label="Password"
        label-for="input-6"
      >
        <b-form-input
          id="input-6"
          v-model="form.password"
          type="password"
          placeholder="Password"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-7"
        label="Password"
        label-for="input-7"
      >
        <b-form-input
          id="input-7"
          v-model="form.confirm_password"
          type="password"
          placeholder="Confirm Password"
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" class="mr-2">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
          </b-card>
          <div class="row" v-if="this.$dev">
            <div class="col-sm-12">{{ form.outlet }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/axios';
import { mapGetters } from "vuex";
import Multiselect from 'vue-multiselect';
  export default {
      components: {
          // Datatable
          'multiselect': Multiselect
      },
    data () {
      let editOrNew = '';
      if (this.$route.params.id) {
      editOrNew = 'Edit User';
    } else {
      editOrNew = 'Create New'
    }
      return {
        outletid: '',
        outlet: '',
        isBusy: false,
        show: true,
        form: {
          name: '',
          email: '',
          phone: '',
          role: null,
          outlet: null,
          password: '',
          confirm_password: '',
        },
        roles: [{ text: 'Select One', value: null }, {text: 'Super Admin', value: 'superadmin'}, {text: 'User', value: 'user'}],
        outlets: [],
        breadcrumb: [
          {
            text: 'Dashboard',
            to: '/'
          },
          {
            text: 'Users',
            to: '/users/all'
          },
          {
            text: editOrNew,
            active: true
          }
        ],
      }
    },
    computed: {
      ...mapGetters(["user"]),
      nameState() {
        return this.form.name.length > 2 ? true : false
      }
    },
    created() {
      this.user.outlet.forEach((outlet) => {
      if (outlet) {
        console.log('outlet', outlet);
        this.userHasOutlet = true;
        this.outlet = outlet;
        this.outletid = outlet.outletid;
      }
    });
    this.getOutlet();

    },
    mounted() {
      if (this.$route.params.id) {
        this.getUser();
      }
      // this.totalRows = this.items.length
    },
    methods: {
      getOutlet() {
        axios.get('outlet/getAll').then((res) => {
          console.log('outlets', res.data.data);
          res.data.data.forEach((val) => {
            return this.outlets.push({
              outletid: val.outletid,
              name: val.name,
              outlet_code: val.outlet_code
            })
          });
          // this.outlets.push(obj);
          console.log('this.outlets', this.outlets);
        });
      },
      async getUser() {
        this.isBusy = true;
        await axios.post('/outlet/user/getById',{
          user_id: this.$route.params.id
        }).then(async (res) => {
          this.isBusy = false;
          let items = res.data.data;
          this.form.name = items.name;
          this.form.email = items.email;
          this.form.phone = items.phone;
          this.form.role = items.role.name;
          this.form.outlet = await this.outlets.find((outlet) => outlet.outletid === Number(items.outletid));
          console.log('this.form.outlet', this.form.outlet);
          
        });
      },
      nameWithCode ({ name, outlet_code }) {
      return `${name} — [${outlet_code}]`
      },
      onSubmit(event) {
        event.preventDefault()
        // alert(JSON.stringify(this.form))
        let path = this.$route.params.id ? '/outlet/user/update' : '/outlet/user/create';
        axios.post(path, {
          user_id: this.$route.params.id ? this.$route.params.id : null,
          name: this.form.name,
          email: this.form.email,
          phone: this.form.phone,
          role: this.form.role,
          outletid: this.form.role === 'user' ? this.form.outlet.outletid : null,
          password: this.form.password,
          password_confirmation: this.form.confirm_password
        }).then((res) => {
          console.log('usr res', res.data);
          if (res.data.status === 200) {
            this.$notifications.notify({
                      message: res.data.message,
                      icon: 'nc-icon nc-check-2',
                          horizontalAlign: 'right',
                          verticalAlign: 'top',
                          type: 'success'
                  });
            setTimeout(() => {
              this.$router.push('/users/all');
            }, 1000);
          }
        }).catch((error) => {
          console.log('error', error.response.data);
          if (error && error.response.data.status !== 200) {
                    for (const err in error.response.data.message) {
                        if (
                            Object.hasOwnProperty.call(
                                error.response.data.message,
                                err
                            )
                        ) {
                      // console.log('validation error', error.response.data.message[err][0]);

                          this.$notifications.notify({
                              message: error.response.data.message[err][0],
                              icon: 'nc-icon nc-notification-70',
                              horizontalAlign: 'right',
                              verticalAlign: 'top',
                              type: 'danger'
                            });
                        }
                    }
                }
        });
      },
      onReset(event) {
        event.preventDefault()
        // Reset our form values
        this.form.email = ''
        this.form.phone = ''
        this.form.name = ''
        this.form.role = null
        this.form.outlet = null
        this.form.password = null
        this.form.confirm_password = null
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    },
  }
</script>